// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkout .checkout-section-title {\n  font-size: 22px;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: #000000;\n}", ""]);
// Exports
module.exports = exports;
